import React from 'react';

const TermsPage = () => {
  return (
    <div className="bg-gray-100 py-12">
      <div className="container mx-auto px-6 bg-white p-8 md:p-12 rounded-lg shadow-md">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">Terms of Service</h1>
        <p className="text-gray-500 mb-8">Effective Date: August 1, 2025</p>

        <div className="space-y-6 text-gray-700">
          <p>These Terms of Service (the "Terms") constitute a legally binding agreement between Syncratik LLC ("Company," "we," "us," or "our") and the business entity or individual (the "Customer," "you," or "your") using our AI Customer Service Agent and related services (the "Service"). By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms.</p>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">1. Definitions</h2>
            <p className="ml-4"><strong>1.1. "AI"</strong> refers to the artificial intelligence model, algorithms, and technology provided as part of the Service.</p>
            <p className="ml-4"><strong>1.2. "Customer Content"</strong> means any data, text, audio, images, or other information that you or your end-users submit to the Service.</p>
            <p className="ml-4"><strong>1.3. "Service"</strong> refers to our AI-powered customer service agent platform, including the AI, its features, any associated software, APIs, and documentation.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">2. License to Use the Service</h2>
            <p className="ml-4"><strong>2.1. Grant of License:</strong> Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your internal business purposes.</p>
            <p className="ml-4"><strong>2.2. Restrictions:</strong> You agree not to: reverse engineer, use the Service for illegal purposes, transmit malicious code, or misuse the service in a way that infringes on intellectual property rights.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">3. Customer Obligations</h2>
            <p className="ml-4">You are responsible for maintaining the confidentiality of your account credentials, ensuring your use of the Service complies with all laws, and for the content you provide.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">4. Intellectual Property</h2>
            <p className="ml-4">We own all rights to the Service. You retain all rights to your Customer Content, but you grant us a license to use it to provide and improve the Service.</p>
          </section>
          
          <section>
             <h2 className="text-2xl font-semibold text-gray-800 mb-3">5. Confidentiality</h2>
             <p className="ml-4">Both parties agree to protect the other's confidential information and not use it outside the scope of this agreement.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">6. Fees and Payment</h2>
            <p className="ml-4">Access is subscription-based and will auto-renew. All payments are non-refundable. We reserve the right to suspend or terminate access for overdue fees.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">7. Term and Termination</h2>
            <p className="ml-4">You may terminate your account at any time. We may terminate the agreement if you breach the terms. Upon termination, your right to use the service ceases and fees are non-refundable.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">8. Warranties and Disclaimers</h2>
            <p className="ml-4">The AI's output is for informational purposes only and may contain errors. The service is provided "AS IS" without warranty of any kind.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">9. Limitation of Liability</h2>
            <p className="ml-4">Our total liability will not exceed the amount of fees paid by you during the twelve months prior to the event giving rise to the liability.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">10. Indemnification</h2>
            <p className="ml-4">You agree to indemnify and defend us from any claims arising from your use of the Service, your breach of these Terms, or your Customer Content.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">11. Governing Law & Dispute Resolution</h2>
            <p className="ml-4">These Terms are governed by the laws of the State of California. Disputes will be resolved through binding arbitration in Los Angeles, California.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;